import { useMutation, useQuery } from '@tanstack/react-query'

import { get, post } from 'utils/http'

import { useCustomerId } from './useCustomerId'

export const useCustomerInternalData = () => {
  const customerId = useCustomerId()

  const updateInternalData = (data: any) => post(`/management/customers/${customerId}/customer_internal_details`, data)

  const { data, isLoading } = useQuery({
    queryKey: ['customer', customerId, 'internal_data'],
    queryFn: () => get(`/management/customers/${customerId}/customer_internal_details`),
  })

  const { mutateAsync } = useMutation({ mutationFn: updateInternalData })

  return {
    data: isLoading || !data ? {} : data,
    update: mutateAsync,
  }
}
